<tool-drawer-container [shouldShowToggleBtn]="false">
  <div class="tool-content-container main-content" *ngIf="dataSource">
    <div style="margin-top: 20px; margin-bottom: 20px">
      <p class="chartjs-title">User registration code generator</p>
      <div class="code-generation-container" style="margin-bottom: 10px">
        <span class="roles-dropdown" style="margin-right: 20px">
          <mat-form-field>
            <mat-label>Select a user role</mat-label>
            <mat-select [(value)]="selectedRoleId">
              @for (role of userRoles(); track role.id) {
              <mat-option [value]="role.id">{{ role.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </span>
        <span class="generate-btn">
          <button
            color="primary"
            mat-raised-button
            [disabled]="!selectedRoleId"
            (click)="saveRegistrationCode()"
          >
            Generate
          </button>
          <button
            *ngIf="generatedCode"
            style="margin-left: 20px"
            color="secondary"
            mat-raised-button
            (click)="generatedCode = ''"
          >
            Clear
          </button>
        </span>
      </div>
      <div class="code-generation-container" *ngIf="generatedCode">
        <span> {{ generatedCode }} </span>
        <span>
          <button
            matTooltip="Copy registration code"
            mat-icon-button
            aria-label="copy icon"
            (click)="copyRegistrationCode()"
          >
            <mat-icon>content_copy</mat-icon>
          </button>
        </span>
      </div>
    </div>
    <div class="chartjs-title">
      <p>Users table</p>
    </div>
    <div class="table-container mat-elevation-z8">
      <table mat-table [dataSource]="dataSource" multiTemplateDataRows>
        <ng-container
          matColumnDef="{{ column }}"
          *ngFor="let column of displayedColumns"
        >
          <ng-container *ngIf="column !== 'action'; else action">
            <th mat-header-cell *matHeaderCellDef class="table-header">
              {{ column.split('_').join(' ') }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ column === 'role' ? element[column]['name'] : element[column]
              }}
            </td>
          </ng-container>
          <ng-template #action>
            <th mat-header-cell *matHeaderCellDef class="table-header">
              Actions
            </th>
            <td mat-cell *matCellDef="let element">
              <button
                matTooltip="Edit user"
                mat-icon-button
                color="primary"
                aria-label="Edit icon"
                (click)="showUser(element); $event.stopPropagation()"
              >
                <mat-icon>edit</mat-icon>
              </button>
              <button
                matTooltip="Delete user"
                mat-icon-button
                color="warn"
                aria-label="Delete icon"
                (click)="deleteUser(element); $event.stopPropagation()"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-template>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td
            mat-cell
            *matCellDef="let element"
            [attr.colspan]="displayedColumns.length"
          >
            <div
              [class]="{'user-interactions-container': element === expandedElement}"
              [@detailExpand]="
                element == expandedElement ? 'expanded' : 'collapsed'
              "
            >
              <div>
                <form
                  [formGroup]="userInteractionsForm"
                  style="display: flex; flex-wrap: wrap; gap: 10px"
                >
                  <mat-form-field>
                    <mat-label>Date Filter</mat-label>
                    <mat-select formControlName="date_range">
                      @for (dateOption of dateFilterOptions; track
                      dateOption.value) {
                      <mat-option [value]="dateOption.value"
                        >{{dateOption.text}}</mat-option
                      >
                      }
                    </mat-select>
                  </mat-form-field>

                  <!-- Start custom date range selection -->
                  <mat-form-field
                    *ngIf="userInteractionsForm.value.date_range === 'customrange'"
                  >
                    <mat-label>Enter a date range</mat-label>
                    <mat-date-range-input
                      [formGroup]="dateRange"
                      [rangePicker]="picker"
                    >
                      <input
                        matStartDate
                        formControlName="start"
                        placeholder="Start date"
                      />
                      <input
                        matEndDate
                        formControlName="end"
                        placeholder="End date"
                      />
                    </mat-date-range-input>
                    <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                    <mat-datepicker-toggle
                      matIconSuffix
                      [for]="picker"
                    ></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>

                    @if (!dateRange.controls.start.valid) {
                    <mat-error>Invalid start date</mat-error>
                    } @if (!dateRange.controls.end.valid) {
                    <mat-error>Invalid end date</mat-error>
                    }
                  </mat-form-field>
                  <!-- End custom date range selection -->

                  <mat-form-field>
                    <mat-label>Pages</mat-label>
                    <mat-select formControlName="pages" multiple>
                      @for (page of pageFilterOptions; track page) {
                      <mat-option [value]="page">{{page}}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>

                  <a
                    mat-fab
                    extended
                    [disabled]="userInteractionsForm.value.date_range === 'customrange' && !dateRange.valid"
                    (click)="generateInteractionCharts(element.id)"
                  >
                    <mat-icon>update</mat-icon>
                    Update
                  </a>
                  <a
                    mat-fab
                    extended
                    style="margin-right: 15px"
                    color="primary"
                    (click)="exportUserInteractionData()"
                  >
                    <mat-icon>download</mat-icon>
                    Download
                  </a>
                </form>

                <div
                  class="user-interactions-content"
                  *ngIf="filteredExpandedUser && filteredExpandedUser.action_data?.length; else no_content"
                >
                  <div class="interactions-count-cards">
                    <mat-card
                      appearance="raised"
                      class="interaction-count-card"
                    >
                      <mat-card-header>
                        <mat-card-title>Total Clicks</mat-card-title>
                        <mat-card-subtitle>{{totalClicks}}</mat-card-subtitle>
                      </mat-card-header>
                    </mat-card>

                    <mat-card
                      appearance="raised"
                      class="interaction-count-card"
                    >
                      <mat-card-header>
                        <mat-card-title>Total Scrolls</mat-card-title>
                        <mat-card-subtitle>{{totalScrolls}}</mat-card-subtitle>
                      </mat-card-header>
                    </mat-card>

                    <mat-card
                      appearance="raised"
                      class="interaction-count-card"
                    >
                      <mat-card-header>
                        <mat-card-title>Total Mouse Move</mat-card-title>
                        <mat-card-subtitle
                          >{{totalMouseMoves}}</mat-card-subtitle
                        >
                      </mat-card-header>
                    </mat-card>

                    <mat-card
                      appearance="raised"
                      class="interaction-count-card"
                    >
                      <mat-card-header>
                        <mat-card-title>Total Key Presses</mat-card-title>
                        <mat-card-subtitle
                          >{{totalKeyPresses}}</mat-card-subtitle
                        >
                      </mat-card-header>
                    </mat-card>
                  </div>

                  <div
                    class="interactions-chart-container"
                    style="
                      display: flex;
                      width: 100%;
                      height: 500px;
                      justify-content: space-between;
                      margin-top: 40px;
                    "
                  >
                    <div class="doughnut-chart" style="width: 30%">
                      <canvas [id]="'interactions-doughnut-chart-' + element.id"
                        >{{interactionDoughnutChart}}</canvas
                      >
                    </div>
                    <div class="stacked-bar-chart" style="width: 70%">
                      <canvas
                        [id]="'interactions-stacked-bar-chart-' + element.id"
                        >{{interactionStackedBarChart}}</canvas
                      >
                    </div>
                  </div>

                  <div
                    style="width: 100%; height: 1000px; margin-top: 40px"
                    [id]="'navigation-sankey-chart-' + element.id"
                  ></div>
                </div>
                <ng-template #no_content>
                  <h3>No data available</h3>
                </ng-template>
              </div>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let element; columns: displayedColumns"
          class="user-data-row"
          [class.example-expanded-row]="expandedElement === element"
          (click)="handleUserClick(expandedElement, element)"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: ['expandedDetail']"
          class="example-detail-row"
        ></tr>
      </table>

      <div class="users-table-bottom-actions">
        <span>
          <mat-form-field>
            <mat-label>Search user</mat-label>
            <input
              matInput
              [(ngModel)]="userSearchValue"
              (ngModelChange)="handleUserSearch($event)"
            />
            <button
              *ngIf="userSearchValue"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="handleUserSearch('')"
            >
              <i class="fas fa-times-circle"></i>
            </button>
          </mat-form-field>
        </span>
        <span>
          <mat-paginator
            [pageSizeOptions]="[20, 50, 100]"
            showFirstLastButtons
            aria-label="Select page of periodic elements"
          >
          </mat-paginator>
        </span>
      </div>
    </div>
  </div>
</tool-drawer-container>
